import * as moment from 'moment';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { QueueStatus } from "../enums/queue-status.enum";

export class QueueEvent {
	queueId: number;
	status: QueueStatus;
	eventTime: Date | string;

	// view model
	label: string;
	icon: string;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (this.status != null && this.status['code'] == null) {
			this.status = UtilHelper.getEnumByCod(this.status, QueueStatus);

			if (this.status == null) {
				this.status = QueueStatus.UNDEFINED;
			}
		}

		if (typeof this.eventTime === 'string') {
			this.eventTime = moment(this.eventTime).toDate();
		}

		switch (this.status['code']) {
			case QueueStatus.IN_QUEUE['code']:
				this.icon = "md-man";
				this.label = "Entrou na fila";
				break;

			case QueueStatus.NOTIFIED['code']:
				this.icon = "md-megaphone";
				this.label = "Chamado";
				break;

			case QueueStatus.CONFIRMED['code']:
				this.icon = "md-checkmark";
				this.label = "Compareceu";
				break;

			case QueueStatus.NO_SHOW['code']:
				this.icon = "md-thumbs-down";
				this.label = "Não compareceu";
				break;

			case QueueStatus.CANCELED_BY_CUSTOMER['code']:
			case QueueStatus.CANCELED_BY_STORE['code']:
				this.icon = "md-close";
				this.label = "Cancelado";
				break;

			default:
				break;
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/queue/models/queue-event.model.ts